var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "port-item" }, [
    _c("div", { staticClass: "port-item-icon" }, [
      _c("span", [_c("img", { attrs: { src: _vm.icon } })]),
      _c("p", [_vm._v(_vm._s(_vm.title))])
    ]),
    _c("p", { staticClass: "port-item-value" }, [
      _vm._v(" " + _vm._s(_vm.value) + " ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }